import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import { useMutationJobDelete } from "../../actions/dashboardActions";
import { useAuth } from "../../context/authContext";
import { useSelector } from "react-redux";
import {
  UsejobDropdowns,
  useDropdown,
  UsecitiesDropdowns,
  useStatesDropdowns,
} from "../../actions/authActions";
import { useForm } from "react-hook-form";
import { SwalAlert } from "../../components";
export default () => {
  const navigate = useNavigate();
  const [loadingapi, setLoadingapi] = useState(false);
  const [loadingJobId, setLoadingJobId] = useState(null);
  const [allcategories, setAllcategories] = useState(true);
  const [seteledcategories, setSeteledcategories] = useState(false);
  const [categoriesTypesJobId, setCategoriesTtypesNewsId] = useState(null);
  const [filterPopup, setFilterPopup] = useState(false);
  const { isLoggedIn } = useAuth();
  const [isFreelance, setIsFreelance] = useState(false);
  const [filters, setFilters] = useState({});
  const user = useSelector((state) => state.app.userData.userData);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const userId = localStorage.getItem("userId");
  const fetchJobTypes = async () => {
    const { data } = await axios.get(`${baseURL}/api/v2/job-types`);
    return data?.data;
  };

  const { data: jobTypes } = useQuery({
    queryKey: ["jobTypes"],
    queryFn: fetchJobTypes,
  });
  const mutation = useMutation({
    mutationFn: async (savedData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/saved-jobs`,
        savedData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return data;
    },
    onSuccess: (data) => {
      setLoadingJobId(null);
      setLoadingapi(false);
      SwalAlert(data?.status, data?.message, "success");
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
      setLoadingJobId(null);
      setLoadingapi(false);
    },
  });

  const mutationJobDelete = useMutationJobDelete(setLoadingapi, 1);
  const {
    data: jobslisting,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: joblisloading,
    refetch: joblistingrefetch,
    isError,
    error,
  } = useInfiniteQuery({
    queryKey: ["jobslisting", filters, userId],
    queryFn: ({ pageParam = 1 }) =>
      axios
        .get(`${baseURL}/api/v2/job`, {
          params: {
            user_id: userId,
            page: pageParam,
            ...filters,
          },
        })
        .then((res) => res.data.data),
    getNextPageParam: (lastPage) => {
      return lastPage.has_more_pages ? lastPage.current_page + 1 : undefined;
    },
  });
  const {
    data: typesByJobslisting,
    fetchNextPage: typesFetchNextPage,
    hasNextPage: typesHasNextPage,
    isFetchingNextPage: typesisFetchingNextPage,
    isLoading: typeslisloading,
    refetch: typesRefetch,
  } = useInfiniteQuery({
    queryKey: ["typesByJobslisting", filters, userId],
    queryFn: ({ pageParam = 1 }) =>
      axios
        .get(`${baseURL}/api/v2/job/types/${categoriesTypesJobId}`, {
          params: {
            user_id: userId,
            page: pageParam,
            ...filters,
          },
        })
        .then((res) => res.data.data),
    getNextPageParam: (lastPage) => {
      return lastPage.has_more_pages ? lastPage.current_page + 1 : undefined;
    },
    enabled:
      categoriesTypesJobId !== null && categoriesTypesJobId !== undefined,
  });

  useEffect(() => {
    if (!joblisloading) {
      setFilterPopup(false);
    }
  }, [joblisloading]);

  useEffect(() => {
    if (categoriesTypesJobId !== null) {
      // Reset to page 1 when job type changes
      typesRefetch(); // Manually trigger React Query fetch
    }
  }, [categoriesTypesJobId]);

  const [select, setSelect] = useState({
    countries: "",
    states: "",
    city: "",
    salary_period: "",
    job_shift: "",
    job_type: "",
    gender: "",
    degree_level: "",
    job_experience: "",
  });
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      jobtitle: "",
      expirydate: "",
      postCode: "",
      salaryFrom: "",
      salaryTo: "",
      positions: "",
      description: "",
      job_shift: "",
    },
  });
  const { data: jobDropdowns } = UsejobDropdowns();
  const { data: dropdowns, isLoading: dropdownLoading } = useDropdown();
  const { data: states, isLoading: isLoadingStates } = useStatesDropdowns(
    select.country
  );
  const { data: cities, isLoading: citiesisLoading } = UsecitiesDropdowns(
    select?.states
  );

  const handleDropdwonSelect = (name, value) => {
    setSelect((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const experiences = [
    { job_experience: null, job_experience_id: null },
    ...(jobDropdowns?.job_experience || []),
  ];

  const [index, setIndex] = useState(0);
  const rangeRef = useRef(null);
  const [tooltipPos, setTooltipPos] = useState(0);

  const handleInput = (e) => {
    const newIndex = parseInt(e.target.value);
    setIndex(newIndex);
    updateTooltipPosition(newIndex);
  };

  const updateTooltipPosition = (val) => {
    const range = rangeRef.current;
    if (range && experiences.length > 1) {
      const percent = val / (experiences.length - 1);
      const rangeWidth = range.offsetWidth;
      setTooltipPos(percent * rangeWidth);
    }
  };

  useEffect(() => {
    updateTooltipPosition(index);
  }, [index, experiences.length]);

  const selectedExperience = experiences[index]?.job_experience;
  const selectedExperienceId = experiences[index]?.job_experience_id;

  const toggleFreelance = () => {
    setIsFreelance((prev) => (prev === 1 ? 0 : 1));
  };

  const handleJobClick = (id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else if (user?.role === "fan") {
      navigate(`/upgrade`);
    } else {
      navigate(`/job-details/${id}`);
    }
  };

  const handleSevedJob = (id, savedJobs) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else if (user?.role === "fan") {
      navigate("/upgrade");
    } else {
      if (savedJobs) {
        setLoadingJobId(id);
        setLoadingapi(true);
        console.log("savedJobs", savedJobs);
        mutationJobDelete.mutate(
          {
            job_id: id,
            user_id: userId,
          },
          {
            onSettled: () => {
              setLoadingJobId(null);
              setLoadingapi(false);
              if (categoriesTypesJobId) {
                typesRefetch();
              } else {
                joblistingrefetch();
              }
            },
          }
        );
      } else {
        setLoadingJobId(id);
        setLoadingapi(true);
        mutation.mutate(
          {
            job_id: id,
            user_id: userId,
          },
          {
            onSettled: () => {
              setLoadingJobId(null);
              setLoadingapi(false);
              if (categoriesTypesJobId) {
                typesRefetch();
              } else {
                joblistingrefetch();
              }
            },
          }
        );
      }
    }
  };

  const handleButtonClick = (id) => {
    setAllcategories(false);
    setSeteledcategories(true);
    setCategoriesTtypesNewsId(id);
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading jobs: {error.message}</p>
      </div>
    );
  }
  const onSubmit = (data, e) => {
    e.preventDefault();
    const newFilters = {};

    if (select.country) newFilters["country_id[]"] = select.country;
    if (select?.states) newFilters["state_id[]"] = select?.states;
    if (select.city) newFilters["city_id[]"] = select.city;
    if (select.gender) newFilters["gender_id[]"] = select.gender;
    if (select.degree_level)
      newFilters["degree_level_id[]"] = select.degree_level;
    if (select.salary_period)
      newFilters["salary_period_id[]"] = select.salary_period;
    if (selectedExperienceId)
      newFilters["job_experience_id[]"] = selectedExperienceId;
    if (Array.isArray(data.job_shift)) {
      newFilters["job_shift_id[]"] = data.job_shift.filter(Boolean); // array
    }
    const salaryFrom = getValues("salaryFrom");
    const salaryTo = getValues("salaryTo");
    if (salaryFrom) newFilters.salary_from = salaryFrom;
    if (salaryTo) newFilters.salary_to = salaryTo;

    newFilters.is_freelance = isFreelance ? 1 : 0;

    setFilters(newFilters); // This triggers the useQuery refetch
  };
  const resetFilters = () => {
    setFilters({});
    setSelect("");
    reset();
    setIsFreelance("");
    setIndex(0);
  };
  return {
    jobslisting,
    handleJobClick,
    handleSevedJob,
    loadingJobId,
    jobTypes,
    allcategories,
    seteledcategories,
    handleButtonClick,
    typesByJobslisting,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    joblisloading,
    categoriesTypesJobId,
    setCategoriesTtypesNewsId,
    filterPopup,
    setFilterPopup,
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    errors,
    dropdowns,
    dropdownLoading,
    states,
    isLoadingStates,
    cities,
    citiesisLoading,
    handleDropdwonSelect,
    experiences,
    index,
    rangeRef,
    tooltipPos,
    handleInput,
    selectedExperience,
    isFreelance,
    toggleFreelance,
    onSubmit,
    resetFilters,
    setAllcategories,
    setSeteledcategories,
    typesisFetchingNextPage,
    select,
    typesHasNextPage,
    typesFetchNextPage,
    typeslisloading,
    jobDropdowns,
  };
};
